export const config = {
  appId: "9fe7507d-8163-4e51-84e7-a731ce4b6afa",
  redirectUri: "http://localhost:3000",
  scopes: [
    "user.read",
    "calendars.read",
    "calendars.readwrite",
    "mailboxsettings.read"
  ]
}